<template>
    <b-modal 
        size="lg" 
        no-close-on-backdrop 
        centered
        hide-footer
        title="Nova Carteira"
        v-model="open"
    >
        <div class="d-block text-center mb-4">
            <h4>Busque o cliente, profissinal  ou empresa.</h4>
        </div>

        <b-row class=" mt-5">
            <span class="container ml-2 mb-2">Selecione a pesquisa por nome ou cpf/cnpj</span>
            <div class="container ml-2 mt-1">
                <b-form-radio-group
                    v-model="filter.typeSearch"
                    :options="options"
                    class="mb-3"
                    value-field="value"
                    text-field="text"
                    disabled-field="notEnabled"
                    @change="filter.name = ''"
                ></b-form-radio-group>
            </div>
            <b-col cols="12" >
                <input
                    v-if="filter.typeSearch == 'name'"
                    type="text"
                    v-model="filter.name"
                    class="form-control ml-2 mr-4"
                    placeholder="Pesquise por nome, razão social ou nome fantasia"
                    @keyup.enter="searchName()"
                />
                <input
                    v-else
                    type="text"
                    v-model="filter.name"
                    v-mask="['###.###.###-##', '##.###.###/####-##']"
                    class="form-control ml-2 mr-2"
                    placeholder="Pesquise pelo cpf ou cnpj"
                    @keyup.enter="searchName()"
                />
            </b-col>
            <b-col>
                <button 
                    class="btn btn-success ml-2 mt-2" 
                    title="Pesquisar" 
                    @click="searchName()"
                    >
                    Pesquisar
                </button>
            </b-col>
        </b-row>
        
        

        <div  class="mt-4 container">
            <FilterTypeClient
                v-model="filter.type"
                @searchType="filterClient($event)"
            />
        </div>

        <b-col cols="12" class="mt-4">
            <span class="ml-2 fs-18">
                {{ table.records.length }} Clientes nesta página em um total de {{ this.pagination.total }} filtrado!
            </span>
          <b-table
            class="mt-3"
            striped
            responsive
            hover
            :fields="table.headers"
            :items="table.records"
            :busy="loading"
            :tbody-tr-class="rowClass"
            show-empty
            empty-text="Nenhum cliente encontrado ou já cadastrado!"
          >
            <template #table-busy>
              <div class="text-center my-2">
                <b-spinner class="align-middle mr-2"></b-spinner>
                <strong>Carregando...</strong>
              </div>
            </template>

            <template #cell(created_at)="data">
              {{ formatDateNew(data.item.created_at) }}
            </template>
            
            <template #cell(type)="data">
              {{ userType(data.item.type) }}
            </template>

            <template #cell(cpf)="data">
                <span v-if="data.item.type == 1">
                    {{ formatCpf(data.item.client.cpf) }}
                </span> 

                <span v-if="data.item.type == 2">
                    <span v-if="data.item.professional.cpf">
                        {{ formatCpf(data.item.professional.cpf) }}
                    </span>
                    <span v-else>
                        {{ formatCnpj(data.item.professional.cnpj) }}
                    </span>
                </span> 

                <span v-if="data.item.type == 3">
                    {{ formatCnpj(data.item.company.cnpj) }}
                </span> 
            </template>

            <template #cell(first_name)="data">
                <span v-if="data.item.type == 1">
                    {{ data.item.client.first_name + ' '+data.item.client.last_name}}
                </span> 
                <span v-if="data.item.type == 2">
                    {{ data.item.professional.name}}
                </span> 
                <span v-if="data.item.type == 3">
                    {{ data.item.company.nome_fantasia }}
                </span> 
            </template>

            <template #cell(action)="data">
                <b-form-radio 
                    v-model="selectedClient" 
                    name="some-radios" 
                    :value="data.item"
                >
                </b-form-radio>
            </template>
          </b-table>
        </b-col>
        <b-col cols="12" class="d-flex align-items-center justify-content-center">
            <b-pagination
                v-model="pagination.currentPage"
                :total-rows="pagination.total"
                :per-page="pagination.itemsPerPage"
                :disabled="loading"
            ></b-pagination>
        </b-col>
        <b-col cols="12" class="d-flex justify-content-end">
            <button 
                class="mt-3 btn btn-width btn-primary" 
                @click="$refs.valueClient.toggleOpen({nameClient})"
                :disabled="selectedClient ? false : true"
            >
                Prosseguir
            </button>
        </b-col>
        <ValueClient
          ref="valueClient"
          @saveClientWallet="addClient($event)"
        />
    </b-modal>
</template>

<script>
import makeToast from '@/mixins/makeToast';
import {mapActions, mapState } from 'vuex';
import ValueClient from '../Wallet/ValueClient.vue'
import FilterTypeClient from '../Wallet/FilterTypeClient.vue'

export default {
    name:'NewClient',
    emits:['getAllClient'],
    mixins: [makeToast],

    components: {
        ValueClient,
        FilterTypeClient,
    },

    data() {
        return  {
            open: false,
            loading: false,
            data: [],
            clientWallet: [],
            cpf:'',
            selectedClient: '',
            searchClient:'',
            nameClient:'',
            newUser_id: '',
            limit:'',
            due: '',
            options: [
                { text: 'NOME', value: 'name'},
                { text: 'CPF/CNPJ', value: 'cpf_cnpj'},
            ],
            filter: {
                type: '',
                name: '',
                typeSearch:'name'
            },
            pagination: {
                currentPage: 1,
                itemsPerPage: 15,
                total: 0,
            },
            table: {
                headers: [
                    {
                        key: 'id',
                        thClass: 'd-none',
                        tdClass: 'd-none',
                    },
                    {
                        key: 'action',
                        label: 'Selecione',
                        sortable: false,
                    },
                    {
                        key: 'first_name',
                        label: 'Cliente',
                        sortable: false,
                    },
                    {
                        key: 'cpf',
                        label: 'CPF ',
                        sortable: false,
                    },
                    {
                        key: 'type',
                        label: 'Tipo',
                        sortable: false,
                    },
                    {
                        key: 'created_at',
                        label: 'Data de cadastro',
                        sortable: false,
                    },
                ],
                records: [],
            },
        }
    },

    watch: {
        'pagination.currentPage': function () {
        this.allClient();
        },
    },

    computed: {
    ...mapState(['dadosUsuario']),
    },
    methods: {
    ...mapActions('shopkeeper', [
      'allWallet',
      'createWallet',
      'updateWallet',
      'deleteWallet',
      'paymentWallet',
      'historyClientWallet',
      'allClientShopkeeper',
      'historyPaymentWalletShopkeeper'
    ]),

    toggleOpen(clientWallet = []) {
        this.open = !this.open;
        this.clientWallet = clientWallet;
        this.filterClient();
    },

    formatDateNew(value){
        let newData = value.slice(0,-17);
        let split = newData.split('-');
        newData = split[2]+'/'+split[1]+'/'+split[0];
        if(this.selectedClient.type == 1){
            this.nameClient = this.selectedClient.client.first_name +' '+this.selectedClient.client.last_name;
        }else if(this.selectedClient.type == 2){
            this.nameClient = this.selectedClient.professional.name;
        }else if(this.selectedClient.type ==3){
            this.nameClient = this.selectedClient.company.nome_fantasia;
        }
        return newData;
    },

    formatCpf(cpf) {
        if(cpf != undefined) {
            cpf = cpf.replace(/[^\d]/g, "");
            return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
        }
    },

    formatCnpj(cnpj) {
        if(cnpj != undefined) {
            return cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
        }
    },

    rowClass(item, type) {
        if (!item || type !== 'row') return
        if (item.id === this.selectedClient.id) return 'table-success'
    },

    userType(type) {
        switch(type){
            case 1:
                return 'Cliente'
                break
            case 2:
                return 'Profisional'
            case 3:
                return 'Empresa'
            default:
                break
        }
    },

    filterClient(type = ""){
        if(type == '') this.filter.typeSearch = 'name';
        this.filter.name = '';
        this.selectedClient = '';
        this.filter.type = type;
        this.allClient();
    },

    searchName(){
        this.filter.type = '';
        this.allClient();
    },

    allClient(){
      this.$store.dispatch('startLoader');

      this.allClientShopkeeper({
        construpUserId: this.dadosUsuario.id,
        currentPage: this.pagination.currentPage,
        type: this.filter.type,
        value: this.filter.name,
        typeSearch: this.filter.typeSearch,
      })
      .then((response) => {
        const data = response.data.data.data ? response.data.data.data : response.data.data;
        this.pagination.total = response.data.data.total ? response.data.data.total : this.table.records.length;
        this.removeDuplicity(data);
      })
      .catch(() => {
          this.makeToast(
              'Erro',
              'Houve um erro ao trazer os dados',
              'danger'
              );
            })
            .finally(() => {
                this.$store.dispatch('endLoader');
      });
    },
    
    removeDuplicity(data){
        this.table.records = [];
        let usersIdClients = [];
        
        this.clientWallet.forEach(client => {
            usersIdClients.push(client.user_id)
        });
        
        data.forEach(item => {
            if(!usersIdClients.includes(item.id)){
                if(this.table.records.length == 0){
                    this.table.records.push(item)
                }else if(!this.table.records.includes(item.id)){
                    this.table.records.push(item)
                }
            }
        });
    },
    
    addClient(value) {
        let data = {};

        data = {
            construp_user_id: this.dadosUsuario.id,
            user_id: this.selectedClient.id, 
            limit: value.limit,
            due: value.due,
            block: 0
        }
        this.$store.dispatch('startLoader');
        this.createWallet(data)
        .then((response) => {
            if(response.data.data.user_id){
                this.$store.dispatch('endLoader');
                this.makeToast(
                    'Successo',
                    'Cadastro realizado com sucesso!',
                    'success'
                );
            }
            else if(response.data.data[0].code){
                this.$store.dispatch('endLoader');
                this.makeToast(
                    'Erro',
                    'Cliente já tem cadastro na carteira!',
                    'danger'
                );
            }else{
                this.$store.dispatch('endLoader');
                this.makeToast(
                'Erro',
                'Houve um erro ao incluir o cliente, favor tentar novamente!',
                'danger'
                );
            }
        })
        .catch(() => {})
        .finally(() => {
            this.open = !this.open;
            this.$emit('getAllClient');
            this.$store.dispatch('endLoader');
        });
    }
    }
}
</script>

<style>
.btn-width {
    width: 200px;
}
</style>